import React from 'react';
import styled from '@emotion/styled';
import usePromoteDays, { PROMOTE_I18N_NS } from 'hooks/business/usePromoteDays';
import { T, useTranslate } from '@tolgee/react';

const Container = styled.div`
  margin: 50px 0 10px 0;
  color: #192544;
  text-align: center;
  h2 {
    font-size: 26px;
    margin-bottom: 0px;
  }
  h3 {
    font-size: 16px;
  }
`;
const Slogon = styled.div`
  position: absolute;
  top: 16px;
  left: 24px;
  color: #515359;
  font-size: 14px;
`;
const Box = styled.div`
  display: inline-block;
  background: #e1edff;
  padding: 8px 10px;
  text-align: center;
  border-radius: 4px;
  line-height: 1.2em;
  strong {
    color: #fd6032;
    font-size: 20px;
    margin: 0 0.2em;
    font-weight: normal;
  }
  > span {
    display: block;
    font-size: 12px;
    color: #84868c;
  }
`;

export interface PromoteContentProps {}

const PromoteContent = (props: PromoteContentProps) => {
  const { promoteLeftDays } = usePromoteDays();
  const { t } = useTranslate();
  return (
    <Container>
      <Slogon>
        {t('subscribe.chat++')}｜{t('subscribe.slogon')}
      </Slogon>
      <h2>
        <T
          ns={PROMOTE_I18N_NS}
          keyName="promote.title"
          params={{
            n: promoteLeftDays,
            num: <strong />,
          }}
        />
      </h2>
      <h3>
        <T
          ns={PROMOTE_I18N_NS}
          keyName="promote.gift"
          params={{
            n: promoteLeftDays,
            num: <strong />,
          }}
        />
      </h3>
      <Box>
        <T
          ns={PROMOTE_I18N_NS}
          keyName="promote.ends.in.N.days"
          params={{ n: promoteLeftDays, num: <strong /> }}
        />
        <span>
          <T ns={PROMOTE_I18N_NS} keyName="promote.end.date" />
        </span>
      </Box>
    </Container>
  );
};
export default React.memo(PromoteContent);
